module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure2.cacbc42b.svg";